import { DialogNames } from 'src/enums'
import { GatewayState } from 'src/api'
import { useDialog } from './useDialog'
import { useAddPopupMessage } from './useAddPopupMessage'
import { usePatchGatewayRequest } from '../api'

export const useGatewayStateUpdate = () => {
  const { openDialog: openGatewayMarkLostDialog, closeDialog: closeGatewayMarkLostDialog } = useDialog(DialogNames.MarkLostSensor)
  const { openDialog: openGatewayMakeAvailableDialog, closeDialog: closeGatewayMakeAvailableDialog } = useDialog(DialogNames.UnarchiveSensor)
  const addPopupMessage = useAddPopupMessage()
  const changeGatewayStateRequest = usePatchGatewayRequest()
  const updateState = (payload: { gatewayId: number; state: GatewayState; onSuccess?: () => void; onError?: () => void }) => {
    const { gatewayId, state, onSuccess, onError } = payload
    changeGatewayStateRequest.mutate(
      {
        gatewayId,
        payload: { stateId: state.id }
      },
      {
        onSuccess: () => {
          addPopupMessage({ text: 'The gateway state has been successfully changed', type: 'success' })
          closeGatewayMarkLostDialog()
          closeGatewayMakeAvailableDialog()
          if (typeof onSuccess === 'function') {
            onSuccess()
          }
        },
        onError: ({ message: text }) => {
          addPopupMessage({ text, type: 'error' })
          if (typeof onError === 'function') {
            onError()
          }
        }
      }
    )
  }

  return {
    updateGatewayState: updateState,
    openGatewayMarkLostDialog,
    closeGatewayMarkLostDialog,
    openGatewayMakeAvailableDialog,
    closeGatewayMakeAvailableDialog,
    isLoadingChangingGatewayState: changeGatewayStateRequest.isLoading
  }
}
